import { render } from "./Contacts.vue?vue&type=template&id=5a2ffada&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=5a2ffada&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2ffada"]])

export default __exports__